@if (selectedBluePrintField) {
<div class="div-right-panel-component">
  <form #myForm="ngForm">
    <fieldset [disabled]="isReadOnly" style="border: none; padding: 0; margin: 0">
      <mat-form-field>
        <input
          matInput
          #inputName
          placeholder="Name (Type:{{ selectedBluePrintField.fieldType }})"
          maxlength="255"
          required
          name="name"
          (blur)="onNameBlur()"
          (focus)="selectName()"
          (keyup)="onChange()"
          type="text"
          [(ngModel)]="selectedBluePrintField.name" />
      </mat-form-field>
      <mat-form-field>
        <input matInput placeholder="Description" type="text" name="description" [(ngModel)]="selectedBluePrintField.description" />
      </mat-form-field>
      <mat-form-field>
        <mat-label>Label</mat-label>
        <input matInput name="label" type="text" [placeholder]="selectedBluePrintField.name" [(ngModel)]="selectedBluePrintField.label" />
      </mat-form-field>
      <mat-form-field>
        <mat-label>Tooltip</mat-label>
        <input matInput name="tooltip" type="text" [placeholder]="selectedBluePrintField.name" [(ngModel)]="selectedBluePrintField.tooltip" />
      </mat-form-field>
      <mat-form-field>
        <input matInput placeholder="Mask expression" type="text" name="maskExpression" [(ngModel)]="FormattedTextField.maskExpression" />
      </mat-form-field>
      <mat-form-field>
        <input matInput placeholder="" style="visibility: hidden; display: none" name="isRequiredInput" />
        <mat-checkbox matInput [(ngModel)]="FormattedTextField.isRequired" [checked]="FormattedTextField.isRequired" name="isRequired">Is required?</mat-checkbox>
      </mat-form-field>
      <mat-form-field>
        <input matInput placeholder="" style="visibility: hidden; display: none" name="isReadOnlyInput" />
        <mat-checkbox matInput [(ngModel)]="FormattedTextField.isReadOnly" [checked]="FormattedTextField.isReadOnly" name="isReadOnlyCheckbox">Is read-only?</mat-checkbox>
      </mat-form-field>
    </fieldset>
    <div class="save-button-div" *ngIf="!isReadOnly">
      <button mat-raised-button color="primary" (click)="saveWork()" [disabled]="!myForm.form.valid || !myForm.form.dirty">Save</button>
    </div>
  </form>
</div>
}
